export default "__VITE_ASSET__055d1b1c__"